import { InMemoryCache } from '../../cache/InMemoryCache';
import { fetchLeadFollowUpHiddenSettings } from './leadFollowUpHiddenSettingsApi';
export const makeLeadFollowUpSettingsCache = () => new InMemoryCache('LeadFollowUpSettingsCache', fetchLeadFollowUpHiddenSettings, key => key);
export const cache = makeLeadFollowUpSettingsCache();

// exported for unit test usage only
export const _resetCache = () => {
  cache.clear();
};